import { Pipe, PipeTransform } from '@angular/core';
import { DashboardModuleService } from '../../dashboard/services/dashboard-module.service';
import has from 'lodash/has';
import { Subject, takeUntil } from 'rxjs';

@Pipe({
  name: 'isMyProfile'
})
export class MyProfile implements PipeTransform {
  userProfile;
  destroy$ = new Subject<void>();
  constructor(private readonly dashboardService: DashboardModuleService) {
    this.dashboardService.userProfileSubscription()
    .pipe(takeUntil(this.destroy$))
    .subscribe((res) => {
      this.userProfile = res;
    });
  }

  readonly transform = (email: string, userName?): boolean => {
    if (email && !userName) {
      if (
        email === this.userProfile?.email ||
        email === this.userProfile?.gsi4pk
      ) {
        return true;
      } else {
        return false;
      }
    } else if (email && userName) {
      return (
        email === this.userProfile?.user_name ||
        (has(this.userProfile, 'refer_id') &&
          email === this.userProfile.refer_id)
      );
    } else {
      return false;
    }
  };

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
